"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pixelratio_directives_1 = require("./pixelratio-directives");
exports.Is1xPixel = pixelratio_directives_1.Is1xPixel;
exports.IsRetina = pixelratio_directives_1.IsRetina;
exports.Is4k = pixelratio_directives_1.Is4k;
exports.PixelRatioInfo = pixelratio_directives_1.PixelRatioInfo;
exports.PIXELRATIO_DIRECTIVES = [
    pixelratio_directives_1.Is1xPixel,
    pixelratio_directives_1.IsRetina,
    pixelratio_directives_1.Is4k,
    pixelratio_directives_1.PixelRatioInfo
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src560599644/src/~/ng2-responsive/pixelratio/index.js
// module id = fz3a
// module chunks = 6